export default __webpack_public_path__ + "static/media/downlight40.12895043.svg";